import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

/** IntraScene staff: look at the app as one customer (null = back to staff). */
export function useSwitchAccount() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const switchTo = async (customerId: number | null) => {
    setBusy(true);
    try {
      const me = await api.viewAs(customerId);
      // Everything cached so far belongs to the other view.
      qc.clear();
      qc.setQueryData(["me"], me);
      nav({ to: "/" });
    } finally {
      setBusy(false);
    }
  };
  return { switchTo, busy };
}
